import { createContext, useContext } from "react";
import { useLayoutGenerator } from "../hooks/useLayoutGenerator";
import { useLayoutMouseEvents } from "../hooks/useLayoutMouseEvents";

export const CardLayoutContext = createContext();

export const CardLayoutContextProvider = ({ children }) => {

    const {
        boundingBox,
        isDragging,
        isBoxColliding,
        handlePlaceholderClick,
        handleCardDragStop,
        handleCardResizeStart,
        handleCardResizeStop,
        handlePlaceholderMouseUp,
        handlePlaceholderMouseDown,
        handlePlaceholderMouseOver
    } = useLayoutMouseEvents();

    const {
        containerRef,
        rowHeight,
        columnCount,
        layout
    } = useLayoutGenerator(boundingBox);

    return (
        <CardLayoutContext.Provider
            value={{
                // Objects
                boundingBox,
                containerRef,
                columnCount,
                rowHeight,
                layout,
                isDragging,

                // Functions
                isBoxColliding,
                handlePlaceholderClick,
                handleCardDragStop,
                handleCardResizeStart,
                handleCardResizeStop,
                handlePlaceholderMouseUp,
                handlePlaceholderMouseDown,
                handlePlaceholderMouseOver
            }}
        >
            {children}
        </CardLayoutContext.Provider>
    );
}

export const useCardLayoutContext = () => useContext(CardLayoutContext);
